package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.extensions.splitByRegex
import com.eladfinish.bible.contest.screens.search.model.ChapterDetails
import com.eladfinish.bible.contest.utils.getRegexOfSingleOtPasukAleph
import com.eladfinish.bible.contest.utils.removeWhitespacesAndParshiot
import com.eladfinish.bible.contest.utils.replaceKtivWithQriNew
import com.eladfinish.bible.contest.utils.replaceOtiotPasuk

class GetChapterVersesUseCase {

    /**
     * @return bookName, chapterName, chapterContent
     */
    operator fun invoke(filenameToLoad: String, assetReader: AssetReader): ChapterDetails {
        val chapterContent = assetReader.readFile(StringConstants.ALL_CHAPTERS + assetReader.fileSeparator + filenameToLoad)
        var bookName = ""
        var chapterName = ""
        var contentBeginning = 0

        StringConstants.Regex.FIRST_VERSE.toRegex().find(chapterContent)?.let {

            bookName = it.groupValues[1]
            chapterName = it.groupValues[2]
            contentBeginning = chapterContent.indexOf(it.groupValues[3])
        }
        chapterContent
            .drop(contentBeginning)
            .replaceKtivWithQriNew()
            .removeWhitespacesAndParshiot()
            .replaceRegex(regex = getRegexOfSingleOtPasukAleph(), replacement = "").trim()
            .replaceOtiotPasuk(literalReplacement = "").trim()
            .replaceRegex(regex = StringConstants.MAKAF.toString(), replacement = " ")
            .replaceRegex(regex = "\\s${StringConstants.PASEQ}\\s", replacement = " ")
            .replaceRegex(regex = "\\s", replacement = " ")
            .trim()
            .splitByRegex(StringConstants.COLON_SPLITTER).filter { it.isNotEmpty() }
            .let {
                return ChapterDetails(bookName, chapterName, it)
            }
    }

}
